import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Box, useTheme, useMediaQuery, Drawer, IconButton } from '@mui/material';
import { useNavigate, Outlet, useParams } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import { useRequest } from 'ahooks';
import { fetchCharacters } from '../api/Rick&MortyReq';
const Heroes = () => {
    var _a;
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 20,
    });
    const navigate = useNavigate();
    const { id } = useParams();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const { data, loading, error } = useRequest(() => fetchCharacters(paginationModel.page + 1), {
        refreshDeps: [paginationModel.page],
    });
    const rows = (data === null || data === void 0 ? void 0 : data.results) || [];
    const totalCount = ((_a = data === null || data === void 0 ? void 0 : data.info) === null || _a === void 0 ? void 0 : _a.count) || 0;
    const columns = [
        { field: 'id', headerName: 'ID', width: 70 },
        { field: 'name', headerName: 'Name', flex: 1, minWidth: 150 },
        { field: 'status', headerName: 'Status', width: 100 },
    ];
    const handleRowClick = (params) => {
        navigate(`/heroes/${params.id}`);
    };
    const closeDetails = () => {
        navigate('/heroes');
    };
    if (error) {
        return _jsx(Box, { sx: { p: 2, color: 'error.main' }, children: "Error loading characters." });
    }
    return (_jsxs(Box, { sx: {
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            height: 'calc(100vh - 100px)',
            gap: 2
        }, children: [_jsx(Box, { sx: { flex: 1, minWidth: 0 }, children: _jsx(DataGrid, { rows: rows, columns: columns, loading: loading, rowCount: totalCount, pageSizeOptions: [20], paginationModel: paginationModel, onPaginationModelChange: setPaginationModel, paginationMode: "server", onRowClick: handleRowClick, autoHeight: isMobile, sx: {
                        bgcolor: 'background.paper',
                        '& .MuiDataGrid-row:hover': { cursor: 'pointer', backgroundColor: 'lightblue' },
                    } }) }), isMobile ? (_jsxs(Drawer, { anchor: "right", open: !!id, onClose: closeDetails, PaperProps: { sx: { width: '100%', maxWidth: '400px', p: 2 } }, children: [_jsx(IconButton, { onClick: closeDetails, sx: { alignSelf: 'flex-start', mb: 2 }, children: _jsx(CloseIcon, {}) }), _jsx(Outlet, {})] })) : (_jsx(Box, { sx: {
                    width: id ? 350 : 0,
                    transition: 'width 0.3s ease',
                    overflow: 'hidden',
                    borderLeft: id ? '1px solid' : 'none',
                    borderColor: 'divider',
                    pl: id ? 2 : 0
                }, children: _jsx(Outlet, {}) }))] }));
};
export default Heroes;
